// extracted by mini-css-extract-plugin
export default {"steps":"Checkout_steps__wsM4f","summary":"Checkout_summary__gjUWh"};